var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#30xxc6uaua)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.246h8.325L23.194 23.87l-1.365 2.885H10.176L0 5.246z",
    fill: "url(#tazm70ii4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.379 15.023h-7.847l1.562-1.954h7.209l.924-1.955h-6.574l1.562-1.956h5.939L32 5.246h-8.336L8.81 23.86l1.367 2.895h15.316l-2.299-2.885 4.186-8.847z",
    fill: "url(#hvvc3y4u2c)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tazm70ii4b",
    x1: 0.328,
    y1: 4.982,
    x2: 19.492,
    y2: 28.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF2431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#73161D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hvvc3y4u2c",
    x1: 16.847,
    y1: 10.765,
    x2: 28.09,
    y2: 24.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF2431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC202C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "30xxc6uaua"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.80d47ee237b40c45bf992ff5b955a54f.svg";
export { ForwardRef as ReactComponent };